import { LOANREQUEST_STATUS_REASONS, LOANREQUEST_STATUSES } from 'cpool-constants';
import { z } from 'zod';

import { schemaGeneralEventApiResponse } from './GeneralResponse';

export const schemaStatusChanged = schemaGeneralEventApiResponse.merge(
    z.object({
        payload: z.object({
            status: z.nativeEnum(LOANREQUEST_STATUSES),
            statusReason: z.array(z.nativeEnum(LOANREQUEST_STATUS_REASONS)).optional(),
        }),
        type: z.literal('KreditDE_LoanRequest_StatusChanged'),
    }),
);

export const schemaStatusEventApiResponse = z.discriminatedUnion('type', [schemaStatusChanged]);

export type StatusEventApiResponse = z.infer<typeof schemaStatusEventApiResponse>;
export type StatusChanged = z.infer<typeof schemaStatusChanged>;
